import { render } from "./MSEditModal.vue?vue&type=template&id=02385c06&scoped=true&ts=true"
import script from "./MSEditModal.vue?vue&type=script&lang=ts"
export * from "./MSEditModal.vue?vue&type=script&lang=ts"

import "./MSEditModal.vue?vue&type=style&index=0&id=02385c06&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02385c06"]])

export default __exports__